export type ConvoComponent = "web-client" | "web-server" | "worker";

export function resolveSentryEnvironment(): string {
  return process.env.SENTRY_ENVIRONMENT?.trim() || process.env.NODE_ENV?.trim() || "development";
}

export function resolveSentryRelease(): string | undefined {
  const release =
    process.env.SENTRY_RELEASE?.trim() || process.env.NEXT_PUBLIC_SENTRY_RELEASE?.trim();
  return release || undefined;
}

export function resolveConvoComponent(fallback: ConvoComponent = "web-server"): ConvoComponent {
  const value = process.env.CONVO_COMPONENT?.trim();
  if (value === "web-client" || value === "web-server" || value === "worker") {
    return value;
  }
  return fallback;
}

export function buildSentryInitOptions(component: ConvoComponent, dsn: string) {
  return {
    dsn,
    environment: resolveSentryEnvironment(),
    release: resolveSentryRelease(),
    initialScope: {
      tags: { component },
    },
    dataCollection: {},
  };
}
